import { Modal as ModalBootstrap } from 'react-bootstrap';
import '../../assets/css/common/modal.css';

const Popup = (props) => {
    const { children, onClose, isShow, size, className, style, btnList = [] } = props;

    const handleModalHide = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <ModalBootstrap
            // CMP-1634
            // react-bootstrap では、OS のアニメーション設定が OFF の場合に、
            // アニメーションの終了検知が上手くできないバグがあり、
            // モーダルを閉じる処理のタイミングが悪いと画面が操作不能になってしまうため、
            // アニメーションを無効にしているので注意
            animation={false}
            size={size ? size : 'xl'}
            centered={true}
            show={isShow}
            onHide={() => handleModalHide()}
            keyboard={false}
            className={`okc-modal ${className}`}
            style={style}
        >
            <div className="okc-modal__body modal-body">
                <div>{children ?? <></>}</div>
            </div>
            <div className="okc-modal__footer modal-footer">
                <div className="okc-modal__button-group">
                    {btnList.map((data, index) => (
                        <button
                            key={index}
                            className={`btn ${data.className}`}
                            data-dismiss="modal"
                            disabled={data.disabled}
                            onClick={() => data.onClick()}
                        >
                            <span className="btn-text">{data.name}</span>
                        </button>
                    ))}
                </div>
            </div>
        </ModalBootstrap>
    );
};

export default Popup;
